import { useDashboardStore } from "./store";

function fmtSize(bytes: number): string {
    if (bytes >= 1_000_000) return (bytes / 1_000_000).toFixed(1) + "MB";
    return (bytes / 1_000).toFixed(0) + "KB";
}

function shortKey(key: string): string {
    // "dvr-clrg-worlds-2026-day-4-hall-b-part-2-1-3975032" → "Day 4 Hall B Pt2"
    const m = key.match(/day.?(\d+).*?(hall.?[ab]).*?part.?(\d+)/i);
    if (m) return `Day ${m[1]} ${m[2].replace(/[^a-zA-Z]/g, "").toUpperCase()} Pt${m[3]}`;
    const m2 = key.match(/day.?(\d+).*?(results)/i);
    if (m2) return `Day ${m2[1]} Results`;
    // Fallback: last meaningful segment
    return key.replace(/^dvr-/, "").replace(/-\d+$/, "").split("-").slice(-3).join(" ");
}

/** Recent chunk downloads — fed by the shared SSE store (no second EventSource) */
export function LiveFeed() {
    const events = useDashboardStore(s => s.recentChunks);

    if (events.length === 0) return null;

    return (
        <div className="panel" style={{ padding: 10 }}>
            <h3 style={{ fontSize: "0.8em", marginBottom: 6 }}>live feed</h3>
            <div style={{ fontSize: "0.75em", fontFamily: "monospace", lineHeight: 1.6 }}>
                {events.map((ev, i) => {
                    const age = Math.round((Date.now() - ev.ts) / 1000);
                    const isAudio = ev.streamKey.endsWith("-audio");
                    return (
                        <div key={`${ev.streamKey}-${ev.sequence}-${i}`} style={{
                            opacity: Math.max(0.3, 1 - i * 0.07),
                            color: isAudio ? "#888" : "#e0e0e0",
                        }}>
                            <span style={{ color: "#33aa55" }}>+</span>{" "}
                            <span style={{ color: "#da4165" }}>{shortKey(ev.streamKey)}</span>{" "}
                            <span style={{ color: "#888" }}>#{ev.sequence}</span>{" "}
                            <span style={{ color: isAudio ? "#555" : "#aa8833" }}>{fmtSize(ev.size)}</span>
                            {age > 0 && <span style={{ color: "#444", marginLeft: 4 }}>{age}s</span>}
                        </div>
                    );
                }).reverse()}
            </div>
        </div>
    );
}
